
<a
  class="ignite-menu-button"
  [class.hide-on-shrink]="hideOnShrink"
  [class.disabled]="disabled"
  [class.selected]="selected || inContext"
  [attr.id]="id ? id : null"
  [attr.label]="label"
  >{{ label }}@if (badgeText?.length > 0) {
  <span class="ignite-menu-button-badge"><span class="ignite-menu-button-badge-text">{{ badgeText }}</span></span>
}</a>
